import(/* webpackMode: "eager" */ "/vercel/path0/apps/portals/src/components/AppPage/AppPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalendarMonth"] */ "/vercel/path0/packages/@wolfejs/icons/IconMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdminPageHeader"] */ "/vercel/path0/packages/@wolfejs/ms-ui/AdminPageHeader/AdminPageHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/@wolfejs/ms-ui/Reports/Report.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/@wolfejs/ms-ui/Reports/ReportForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/@wolfejs/ms-ui/Reports/ReportsList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/@wolfejs/ui/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/@wolfejs/ui/Card/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/vercel/path0/packages/@wolfejs/ui/Text/Text.tsx");
